import SVG from "react-inlinesvg";
import { NavLink } from "react-router-dom";
import MenuLink from "../MenuLink";

const GlobalSidebar = () => {
  
  return (
    <>
      <div className="sidebar">
        <ul className="list-unstyled side-menu">
          <li className="item">
            <MenuLink to={"/dashboard"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/home.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link">Home</span>
            </MenuLink>
          </li>
          {/* <li className="item">
            <MenuLink to={"/history"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/watch.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link">History</span>
            </MenuLink>
          </li> */}
          {/* <li className="item">
            <MenuLink to={"/order-status"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/OrderKiddo.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link text-nowrap">Order Status</span>
            </MenuLink>
          </li> */}
          {/* <li className="item">
            <MenuLink to={"/settings"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/cog.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link">Settings</span>
            </MenuLink>
          </li> */}

          <li className="item logout-item">
            <NavLink to={"/logout"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/logout.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link">Logout</span>
            </NavLink>
          </li>
        </ul>
        <ul className="list-unstyled side-menu bottom-side-menu">
          <li className="item mb-2">
            <NavLink to={"/logout"} className="nav-link">
              <span className="icon">
                <SVG
                  src="Assets/Images/Icons/logout.svg"
                  className="fill-svg"
                  width="24"
                  height="24"
                />
              </span>
              <span className="text-link">Logout</span>
            </NavLink>
          </li>
          <li className="item">
            <div className="nav-link">
              <span className="empty-logo"></span>
              <span className="text-link">
                <SVG src="Assets/Images/Logos/kiddo.svg" />
              </span>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default GlobalSidebar;
